import CategoryItem from 'components/Blocks/Categories/PromotedCategories/CategoryItem/CategoryItem';
import Breadcrumbs from 'components/Layout/Breadcrumbs/Breadcrumbs';
import { Webline } from 'components/Layout/Webline/Webline';
import CatalogListStyled from 'components/Pages/Catalog/Catalog.style';
import { useCatalog } from 'connectors/categories/Catalog';
import useTranslation from 'next-translate/useTranslation';

const Catalog: FC = () => {
    const { t } = useTranslation();
    const categories = useCatalog();

    if (categories === undefined) {
        return null;
    }

    return (
        <>
            <Webline>
                <Breadcrumbs key="breadcrumb" breadcrumb={[{ name: t('Catalog'), slug: '/catalog' }]} />
            </Webline>
            <Webline>
                <h2>{t('Catalog')}</h2>
                <CatalogListStyled>
                    {categories.map((listedItem) => (
                        <CategoryItem key={listedItem.uuid} listedItem={listedItem} />
                    ))}
                </CatalogListStyled>
            </Webline>
        </>
    );
};

export default Catalog;
